import { Trans as I18nTrans } from 'react-i18next';

// Abstract the rest when needed
interface TransProps {
  textKey: string;
  params?: Record<string, string | number>;
}

export function Trans({ textKey, params }: TransProps) {
  return <I18nTrans i18nKey={textKey} keyParams={params} />;
}
